import React, { useContext } from 'react';
import '../styles/Header.scss';
import { LanguageContext } from '../context';

function Footer() {
  const { t } = useContext(LanguageContext);

  return (
    <footer>
      <div className='flex flex-wrap justify-center items-center max-w-7xl mx-auto p-4 lg:p-6 gap-x-3 lg:gap-9'>

        <a target='_blank' rel='noreferrer' download href={'/CGU_Application WeCar.pdf'} className='footer-link hover'>
          {t('footer.cgu_application')}
        </a>
        <a target='_blank' rel='noreferrer' download href={'/CGU_Service_WeCar.pdf'} className='footer-link hover'>
          {t('footer.cgu_service')}
        </a>
        <a target='_blank' rel='noreferrer' download href={'/Politique de confidentialité_WeCar.pdf'} className='footer-link hover'>
          {t('footer.privacy_policy')}
        </a>
        <a target='_blank' rel='noreferrer' download href={'/Politique Cookies_WeCar.pdf'} className='footer-link hover'>
          {t('footer.cookies_policy')}
        </a>
        <span className='footer-link'>
          {`©wecar-${new Date().getFullYear()}`}
        </span>
      </div>

    </footer>

  )
}

export default Footer
